// removed by extract-text-webpack-plugin
module.exports = {"right":"right__zMdAB","left":"left__3rY7T","up":"up__3rgZc","down":"down__1P1iu","Arrow":"Arrow__36XLK"};


//////////////////
// WEBPACK FOOTER
// ./components/Header/Arrow/style.scss
// module id = BjJe
// module chunks = 0